export default{
    datosphp:[],
    act:null,
    fields:null,
    error:null,
    errorMessage:'',
    totalRow:null
}